<template>
  <div class="items-list">
    <div class="item-list" v-for="(item,k) in data.content.items" :key="k">
      <ProductComponent :key="k" v-if="item.sku != null" :data="prepareData(item)" :category="category" :indice="indice"/>
      <BannerComponent :key="k" v-if="item.sku == null" :data="prepareData(item)" :category="category" :indice="indice"/>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import BannerComponent from './BannerComponent'
import ProductComponent from './ProductComponent'
export default {
  name: 'List',
  props: {
    data: Object,
    indice: Number,
    category: String
  },
  methods: {
    prepareData (info) {
      if (info.sku !== null) {
        return this.$parent.$parent.productsData[info.sku]
      } else {
        return info
      }
    }
  },
  components: {
    BannerComponent,
    ProductComponent
  },
  data () {
    return {
      test: 'Test'
    }
  },
  mounted () {
    if (this.$parent.$parent.isMobile === false) {
      let calculateWidth = this.data.content.items.length > 2 ? (this.data.content.items.length / 2) * 250 : 250;
      let slug = 'NO-DETECTADA'
      if(typeof this.category == "string"){
        slug = this.category.replace(/ /g, '-');
        slug = slug.replace(/á/g, 'a');
        slug = slug.replace(/é/g, 'e');
        slug = slug.replace(/í/g, 'i');
        slug = slug.replace(/ó/g, 'o');
        slug = slug.replace(/ú/g, 'u');
        slug = slug.replace(/Á/g, 'a');
        slug = slug.replace(/É/g, 'e');
        slug = slug.replace(/Í/g, 'i');
        slug = slug.replace(/Ó/g, 'o');
        slug = slug.replace(/Ú/g, 'u');
        slug = slug.replace(/ñ/g, 'n');
        slug = slug.replace(/Ñ/g, 'N');
      }
      document.querySelector('#category-' + slug + ' #module' + this.indice).style.width = calculateWidth + 'px'
    }
  }
}
</script>
<style scoped>
  .item-list { display:inline-block;width:45%; margin:10px 2%;vertical-align:top}
  .item-container,.image-frame { width: 100%; }
  .image-frame { width:100%; }
  .image-frame img{ width:100%; }
  .title { font-size:16px; text-align:left; }
  .discount { width:40px;height:40px;background-color:#000;line-height:42px;color:#fff;border-radius:20px;position:absolute;top:10px;left:10px }
  .price,.sale { margin:0px;text-align:left }
  .price { text-decoration:line-through; }
  .sale { font-weight: bold; }
  .go-btn { color: #fff;background-color: #ff8000;display: block;width: 100%;margin: 5px auto;padding: 3px 0px;text-decoration: none; }
  @media only screen and (min-width: 1000px) {
   .items-list{white-space: normal;}
   .item-list { display:inline-block;width:220px; margin:10px;}
  }
</style>



// WEBPACK FOOTER //
// src/components/ListComponent.vue